import styled from 'styled-components';
import { Container } from '../../../ui/gridSystem';

export const PageContainer = styled.div`
  padding: 3rem 2rem 4rem;
`;

export const Title = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 8px;

  @media ${(props) => props.theme.device.mobileL} {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const PageGrid = styled.div`
  display: grid;
  grid-template-columns: 22% 1fr;
  gap: 28px;

  .category-title {
    margin: 0 28px 12px 0;
    border-bottom: 1px solid ${({ theme }) => theme.colors.themeColor};
  }

  @media ${(props) => props.theme.device.tabletL} {
    grid-template-columns: 25% 1fr;
    gap: 16px;
  }

  @media ${(props) => props.theme.device.mobileL} {
    display: block;
  }
`;

export const Wrapper = styled.div`
  .courses-count {
    font-weight: 400;
    font-size: 20px;
    line-height: 24px;
    padding-top: 32px;
  }
`;

export const FiltersContainer = styled.div`
  width: 100%;
  margin-bottom: 32px;
  margin-top: 42px;
`;

export const Filter = styled.div`
  min-width: 115px;
  width: fit-content;

  & > div:first-child {
    margin-bottom: 10px;
  }

  & .level {
    &.l-1::before {
      content: '-';
      margin-right: 4px;
    }
    &.l-2::before {
      content: '-';
      margin-right: 4px;
      margin-left: 10px;
    }
    &.l-3::before {
      content: '-';
      margin-right: 4px;
      margin-left: 20px;
    }
    &.l-4::before {
      content: '-';
      margin-right: 4px;
      margin-left: 30px;
    }
  }
`;

export const SelectsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 20px;

  @media (min-width: 1280px) {
    justify-content: unset;
  }

  @media ${(props) => props.theme.device.tabletL} {
    width: 100%;
    margin-bottom: 20px;
  }

  @media ${(props) => props.theme.device.mobileL} {
    width: 100%;
    flex-direction: column;
  }
`;

export const TabsContainer = styled.div`
  margin-top: 40px;
  display: flex;
  flex-direction: row;
  justify-content: center;

  // Filter Tabs on two row and center alignment
  > div {
    max-width: 70%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    @media ${(props) => props.theme.device.tabletL} {
      max-width: 100%;
    }

    > div {
      margin-bottom: 10px;
    }
  }

  @media ${(props) => props.theme.device.tabletL} {
    text-align: center;
  }
`;

export const Legend = styled.div`
  display: grid;
  grid-template-columns: 120px 2.5fr 1fr 40px;
  padding: 24px;
  gap: 10px;

  .h3-5 {
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.textSecondary};
  }

  @media ${(props) => props.theme.device.tabletL} {
    text-align: center;
    grid-template-columns: 80px 2.5fr 1fr 40px;
    padding: 24px 16px;
  }
`;

export const CourseItem = styled(Legend)`
  position: relative;
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 4px 20px 0px rgba(104, 104, 104, 0.1);
  margin-bottom: 16px;

  .code {
    text-transform: uppercase;
  }

  .tooltip-wrapper {
    position: absolute;
    right: 24px;
    top: 24px;

    @media ${(props) => props.theme.device.mobileL} {
      position: static;
      width: 40px;
      margin-left: auto;
    }
  }

  @media ${(props) => props.theme.device.mobileL} {
    text-align: center;
    grid-template-columns: 80px 1fr;
    width: var(--full-width);
    margin-left: -16px;
    margin-bottom: 0;
    border-bottom: 1px solid ${({ theme }) => theme.colors.border};
    text-align: left;

    > *:nth-child(even) {
      text-align: right;
    }
  }
`;

export const ViewMore = styled.div``;

export const CategoriesWrapper = styled.div`
  max-height: 1300px;
  overflow-y: auto;
  padding-right: 28px;

  // scrollbar style
  /* width */
  &::-webkit-scrollbar {
    width: 5px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: none;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #595959;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: #595959;
  }
`;

export const ResultsSorting = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  .found-results {
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 24px;
    color: ${({ theme }) => theme.colors.black};
  }
`;

export const CategoryCard = styled.button`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 9px 8px;
  gap: 16px;
  background: ${({ theme }) => theme.colors.lightCard};
  border-radius: 4px;
  margin-bottom: 14px;
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.focusRing};
    outline-offset: -2px;
    border-radius: 4px;
  }

  .label {
    padding-left: 12px;
    color: ${({ theme }) => theme.colors.link};
  }

  .number {
    color: ${({ theme }) => theme.colors.white};
    background: ${({ theme }) => theme.colors.themeColor};
    border-radius: 9px;
    padding: 2px 8px;
  }

  &.active {
    .label {
      font-weight: 600;
      color: ${({ theme }) => theme.colors.focusSelect};
      border-left: 3px solid ${({ theme }) => theme.colors.focusSelect};
    }
    .number {
      background: ${({ theme }) => theme.colors.focusSelect};
    }
  }
`;

export const PageWrapper = styled.div`
  display: none;

  &.active {
    display: block;
  }
`;

export const CourseListContainer = styled(Container).attrs(() => ({
  className: 'p-0',
}))``;
